//@ts-nocheck
import { BrowserRouter as Router, Route, Routes, useParams, Navigate } from "react-router-dom";
import PublicRoutes from "./PublicRoutes";
import PrivateRoutes from "./PrivateRoutes";
import ApplyJob from "../pages/ApplyJob";
import JobDetails from "../pages/JobDetails";
import MyDetails from "../pages/MyDetails";
import Login from "../pages/Login";
import AuthValidation from "../pages/AuthValidation";
import JobListing from "../pages/JobListing";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../hooks/useAppDispatch";
import { fetchJobs } from "../store/slices/jobs/jobSlice";
import JobDataProvider from "../components/JobDataProvider";
import JobDetailsProvider from "../components/JobDetailsProvider";
import ApplicationList from "../pages/ApplicationList/ApplicationList";
import ApplicationLayout from "../pages/ApplicationDetails/ApplicationLayout";
import ApplicationDetail from "../pages/ApplicationDetails/ApplicationDetail";
import AiInterview from "../pages/ApplicationDetails/AiInterview";
import ApplicationTasks from "../pages/ApplicationDetails/ApplicationTasks";
import ApplicationMessages from "../pages/ApplicationDetails/ApplicationMessages";
import ApplicationQuestionnaire from "../pages/ApplicationDetails/ApplicationQuestionnaireData.tsx/ApplicationDyanamic";
import AppQuestionnaire from "../pages/ApplicationDetails/ApplicationQuestionnaireData.tsx/AppQuestionnaire";
import ApplicationTaskMeeting from "../pages/ApplicationDetails/ApplicationTaskMeeting";
import { HelmetProvider } from "react-helmet-async";
import NotFound from "../pages/NotFound";

const ProtectedApplicationRoute = ({ children }) => {
  const isAuthenticated = Boolean(localStorage.getItem('accessToken'));
  const { base_slug, jobId } = useParams();

  if (!isAuthenticated) {
    // Redirect to the job listing page if not authenticated
    return <Navigate to={`/`} replace />;
  }

  return children;
};

const AppRoutes = () => {
  const { base_slug, jobId } = useParams(); // Get both parameters
  const helmetContext = {};


  return (
    <Router>
      <HelmetProvider context={helmetContext}>
        <Routes>
          {/* Public Routes */}
          <Route element={<JobDataProvider><PublicRoutes /></JobDataProvider>}>
            <Route path="/:base_slug">
              <Route index element={<JobListing />} />
              <Route path=":jobId" element={<JobDetailsProvider><JobDetails /></JobDetailsProvider>} />
              <Route path=":jobId/apply" element={<JobDetailsProvider><ApplyJob /></JobDetailsProvider>} />


              {/* application */}

              <Route path=":jobId/app/:appId" element={
                <ProtectedApplicationRoute>
                  <ApplicationLayout />
                </ProtectedApplicationRoute>
              }>
                <Route index element={<ApplicationDetail />} />
                <Route path="details" element={<ApplicationDetail />} />
                <Route path="tasks" element={<ApplicationTasks />} />
                <Route path="ai_interview" element={<AiInterview />} />
                <Route path="tasks/questionnaire/:QuestionId" element={<AppQuestionnaire />} />
                <Route path="tasks/meeting/:MeetingId" element={<ApplicationTaskMeeting />} />
                <Route path="messages" element={<ApplicationMessages />} />
              </Route>
            </Route>
          </Route>
          <Route path="/applications" element={
            <ProtectedApplicationRoute>
              <ApplicationList />
            </ProtectedApplicationRoute>
          } />


          <Route path="/" element={<AuthValidation />} />

          <Route path="/404" element={<NotFound />} />

          {/* Catch-all Route for Not Found */}
          <Route path="*" element={<NotFound />} />

        </Routes>
      </HelmetProvider>

    </Router>
  );
};

export default AppRoutes;
